import { useCurrentAccount } from '@application/api';
import { useRouter } from '@application/utils';
import { LoadingOverlay } from '@presentation/components';
import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';
import { Navigate } from 'react-router';
import type { MtRouteProps } from './types';

export * from './types';

export const MtRoute: FC<MtRouteProps> = (props) => {
  const { currentAccountLoggedIn, currentAccountType, currentAccountLoading } = useCurrentAccount();
  const { translatedRoute } = useRouter();

  const { buyer, breeder } = props;

  const componentToRender: ReactNode = useMemo(() => {
    if (typeof window === 'undefined') return null;
    if (currentAccountLoading) return <LoadingOverlay isLoading />;
    if (currentAccountType === 'buyer' && buyer) return buyer;
    if (currentAccountType === 'breeder' && breeder) return breeder;
    return <Navigate replace to={translatedRoute('mtLanding')} />;
  }, [currentAccountLoading, currentAccountType, buyer, breeder, translatedRoute]);

  return currentAccountLoggedIn ? componentToRender : <Navigate to={translatedRoute('login')} />;
};
